import { mapState, mapActions, mapGetters } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import ColoredStateBadge from '@components/coloredStateBadge';
import OuterLink from '@components/outerLink';

const dataLoadingOptions = { getterName: 'getMessages', contentName: 'messages' };
const paginationOptions = { contentName: 'messages' };
const searchOptions = {
  initialSearchDataStates: [
    'outerId', 'state',
  ],
  customTypes: {
    state: 'number',
  },
};

const messagesHeaders = Object.freeze([
  { text: 'Outer ID', value: 'outerId' },
  { text: 'First Attempt', value: 'firstAttempt' },
  { text: 'Last Attempt', value: 'lastAttempt' },
  { text: 'Next Attempt', value: 'nextAttempt' },
  { text: 'State', value: 'state' },
  { text: 'Reason', value: 'reason', width: '20%' },
]);

export default {
  name: 'Messages',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  components: {
    ColoredStateBadge,
    OuterLink,
  },
  data() {
    return {
      messagesHeaders,
    };
  },
  computed: {
    ...mapState('messages', ['messages']),
    ...mapGetters('enums', ['messageStateEnum']),
    messageStateOptions() {
      return this.messageStateEnum.map(({ value, name: text }) => ({ value, text }));
    },
    searchFieldsConfig() {
      return [
        { value: 'outerId', label: 'Outer ID', type: 'text' },
        {
          value: 'state',
          items: this.messageStateOptions,
          label: 'State',
          type: 'select',
        },
      ];
    },
  },
  watch: {
    suffix() {
      this.$_refreshData();
    },
  },
  methods: {
    ...mapActions('messages', ['getMessages']),
  },
};
